// This is the scss entry file
import "../styles/index.css";

// We can import other JS file as we like
import Jumbotron from "../components/jumbotron";

async function startTourStepCheck(currentStep, checkUrl, redirectUrl, checkInterval) {
  const response = await fetch(checkUrl, {
    method: "GET",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    }
  });
  if(response.ok) {
    const text = await response.text();
    if(parseInt(text) != currentStep) {
      window.location.href = redirectUrl;
    } else {
        setTimeout(function() {
            startTourStepCheck(currentStep, checkUrl, redirectUrl, checkInterval);
        }, checkInterval);
    }
  }
}

function handleDataToggleClick(e) {
  e.preventDefault();
  const targetId = e.target.closest('[data-toggle]').getAttribute('data-target');
  if(targetId) {
    const targetElem = document.querySelector(targetId);
    const overlayElem = targetElem.querySelector('.overlay');
    const bodyElem = targetElem.querySelector('.modal-body');
    if(overlayElem.classList.contains('opacity-100')) {
      overlayElem.classList.remove('ease-out');
      overlayElem.classList.remove('duration-300');
      overlayElem.classList.remove('opacity-100');
      bodyElem.classList.remove('ease-out');
      bodyElem.classList.remove('duration-300');
      bodyElem.classList.remove('opacity-100');
      bodyElem.classList.remove('-translate-y-4');
      setTimeout(function() {
        targetElem.style.display = 'none';
      }, 200);
    } else {
      targetElem.style.display = 'block';
      setTimeout(function() {
        overlayElem.classList.add('ease-out');
        overlayElem.classList.add('duration-300');
        overlayElem.classList.add('opacity-100');
        bodyElem.classList.add('ease-out');
        bodyElem.classList.add('duration-300');
        bodyElem.classList.add('opacity-100');
        bodyElem.classList.add('-translate-y-4');
      }, 10);
      
    }
  }
}

function checkAnswerSubmitButton(form) {
  let formId = form.getAttribute("id");

  let foundChecked = false;
  for (const input of form.querySelectorAll("input[type='radio'], input[type='checkbox']")) {
    if(input.checked) {
      foundChecked = true;
      break;
    }
  }

  for (const subBtn of document.querySelectorAll("button[type='submit'][form='" + formId + "']")) {
    if(foundChecked && subBtn.classList.contains("disabled"))
      subBtn.classList.remove("disabled");
    else if(!foundChecked && !subBtn.classList.contains("disabled"))
      subBtn.classList.add("disabled");
  }
}

window.document.addEventListener("DOMContentLoaded", function () {
  window.console.log("dom ready");

  document.addEventListener('click', function(e) {
    if(e.target.closest('[data-toggle]')) {
      handleDataToggleClick(e);
    }
  });

  document.addEventListener('change', function(e) {
    const languageRadio = e.target.closest(".language-form input[type='radio']");
    if(languageRadio) {
      languageRadio.closest('form').submit();
      return;
    }

    const answerInput = e.target.closest(".question-form input[type='radio'], .question-form input[type='checkbox']");
    if(answerInput) {
      checkAnswerSubmitButton(answerInput.closest("form"));
    }
  });

  for (const elem of document.querySelectorAll("form.question-form")) {
    checkAnswerSubmitButton(elem);
  }

  for (const elem of document.querySelectorAll(".disabled[data-delay-enabled]")) {
    setTimeout(function() {
      elem.classList.remove("disabled");
    }, parseInt(elem.getAttribute("data-delay-enabled")));
  }

  // Find elements and initialize
  for (const elem of document.querySelectorAll(Jumbotron.selector())) {
    new Jumbotron(elem);
  }
});

export let QuizzTour = {
  "startTourStepCheck": startTourStepCheck
};

window.QuizzTour = window.QuizzTour || QuizzTour;
